/** Imported by client components: must stay free of `next/headers`. */

/** Every segment of a tzdb id starts with an uppercase letter (`America/Port-au-Prince`, `EST`). */
const TZDB_ID = /^[A-Z][^/]*(\/[A-Z][^/]*)*$/

// Intl validates because supportedValuesOf rejects device aliases like US/Pacific. Its resolved
// id varies by ICU version and can be a deprecated link, so it is only used to repair casing.
export function normalizeTimezone(value: unknown): string | undefined {
  if (typeof value !== 'string' || value.length === 0) return undefined

  let resolved: string
  try {
    resolved = new Intl.DateTimeFormat(undefined, { timeZone: value }).resolvedOptions().timeZone
  } catch {
    return undefined
  }

  if (/^[+-]/.test(resolved)) return undefined
  if (resolved.toLowerCase() === value.toLowerCase()) return resolved
  return TZDB_ID.test(value) ? value : undefined
}

export function getDeviceTimezone(): string | undefined {
  try {
    return normalizeTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)
  } catch {
    return undefined
  }
}
